import { ResponseData } from "@/typings";
import { TProductResponse } from "@/typings/home";
import { fetchYooFindsApi } from "@/utils/fetch";
import { getUri } from "@/utils/url";
import {
  GetFetchProductListParams,
  GetProductSearchV3Params,
} from "./interface";

export async function fetchBlack5ProductList(
  params: GetFetchProductListParams
) {
  return await fetchYooFindsApi<ResponseData<TProductResponse>>(
    getUri("api/black", params)
  );
}

export async function fetchProductSearchV3(params: GetProductSearchV3Params) {
  return await fetchYooFindsApi<ResponseData<TProductResponse>>(
    "api/searchV3",
    {
      method: "POST",
      body: JSON.stringify(params),
    }
  );
}
